import { useGrowthBook } from '@growthbook/growthbook-react';

export const useIsGrowthbookReady = () => ({ ready: useGrowthBook().ready });
